/**
*  Copyright (c) 2022 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Component, ViewEncapsulation, OnInit, Input, ViewChild } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { StoreItemDetailService } from '../services/storeitemdetail.service';
import { StoreItemDetailResponse } from '../model/storeitemdetailresponse';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { StoreItemRequest, CustomFieldRequest } from '../model/storeitemrequest';
import { AlertService } from '../../../../shared/alert/alert.service';
import { AlertMessage } from '../../../../shared/alert/alertmessage';
import { StoreFilterComponent } from './storefilter.component';
import { StoreItemFileUpload } from '../model/storeitemfileupload';
import { CustomField } from '../../shared/model/customfieldsresponse';
import { SpinnerService } from '../../../../shared/spinner/spinner.service';
import { CustomerPreferenceService } from '../../../preference/customerpreference.service';
import { CustomerPreferenceResponse } from '../../../preference/customerpreference.model';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { ZSDTranslateService } from '../../../../common/zsd-translate.service';
import { FileUploadStatus } from '../model/fileuploadstatus';
import { ClientInfo, CustomerSearchInfoResponse } from '../../requests/model/clientinfo';
import { RequestDetailService } from '../../requests/services/request-detail.service';
import { RequestDetailResponse, CustomFormField } from '../../requests/model/requestdetailresponse';
import { RequestNotes } from '../../requests/model/requestnotesresponse';
import { RequestInfo } from '../../requests/model/requestinforesponse';
import { RequestCustomFieldInfo } from '../../requests/model/requestcustomfieldinforesponse';
import { RequestslistService } from '../../requests/services/requestslist.service';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';
import { ZsdFormIOComponent } from '../../newrequest/quickcall/zsdformio/zsdformio.component';
import * as $ from 'jquery';


@Component({
  selector: 'zsd-storeitemdetail',
  templateUrl: '../view/storeitemdetail.component.html',
  styleUrls: ['../view/storeitemdetail.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})

export class StoreItemDetailComponent implements OnInit {
  @ViewChild(ZsdFormIOComponent, { static: false }) formio;
  @Input() index: number;
  ccList: ClientInfo[] = new Array();
  ccField = new FormControl();
  currentCcUserIndex = -1;
  ccUserSearchResultCount = 0;
  requestDetailResponse: RequestDetailResponse = new RequestDetailResponse();
  requestNotesResponse = new Array<RequestNotes>();
  requestInfo: RequestInfo = new RequestInfo();
  requestCustomfield = new Array<RequestCustomFieldInfo>();
  customFormField = new Array<CustomFormField>();
  maxLength = 350;
  currentText: string;
  public isCollapsed = true;
  matrix = [];
  usersLoading = false;
  users: Observable<CustomerSearchInfoResponse>;

  storeItemDescription: string;
  storeItemId: number;
  showNotifyField;

  storeItemDetail: StoreItemDetailResponse = new StoreItemDetailResponse();
  storeItemRequest: StoreItemRequest = new StoreItemRequest();
  storeItemFileUpload: StoreItemFileUpload = new StoreItemFileUpload();

  serverError = null;
  storeItemDetailForm: FormGroup;
  storeItem = false;
  searchString = '';
  public validFileList: Array<File> = [];
  fileUploadForm: boolean;
  showAdditionalInfo;
  targetDeviceId: number;
  loading = false;

  defaultTargetDevice = -1;
  userSearchCurrentDisplayedCount: number;
  userSearchOffset: number;
  userSearchLimit: number;
  userSearchTerm: string;
  userSearchInfo: CustomerSearchInfoResponse;
  formSchema = new Array();

  constructor(public formBuilder: FormBuilder, private spinnerService: SpinnerService, private route: ActivatedRoute,
    public router: Router, public _DomSanitizer: DomSanitizer,
    private storeitemdetailservice: StoreItemDetailService, public alertService: AlertService,
    public customerPreferenceService: CustomerPreferenceService, public zsdTranslate: ZSDTranslateService,
    public requestDetailService: RequestDetailService, public requestListService: RequestslistService) {
    this.spinnerService.show();
    this.targetDeviceId = this.defaultTargetDevice;
  }



  ngOnInit() {

      this.users = this.ccField.valueChanges.pipe(
        debounceTime(400),
        distinctUntilChanged(),
        // filter((searchTerm) => (searchTerm.length > 1)),
        tap(() => this.usersLoading = true),
        switchMap(searchTerm => {
          this.userSearchTerm = searchTerm;
          return this.requestDetailService.findUser(searchTerm , 0 , 10);
        }),
        tap((resp) => {
          // if (resp) {
          //   this.searchListFlag = true;
          // }
          this.usersLoading = false;
          this.userSearchOffset = 0;
          this.userSearchLimit = 10;
          this.ccUserSearchResultCount = resp.resultCount;
          this.userSearchCurrentDisplayedCount = resp.results.length;
        })
      );

      this.users.forEach((info) => {
        this.userSearchInfo = info;
      });

    this.customerPreferenceService.getPreferenceList().subscribe(
      (preferences: CustomerPreferenceResponse) => {
        this.showAdditionalInfo = preferences.showAdditionalInfo;
        this.showNotifyField = preferences.showNotify;
       },
      err => console.error(err)
    );

    this.route.params.subscribe(params => {
      this.storeItemId = params['id'];
    });

    // fetching store item details
    this.storeitemdetailservice.getStoreItemDetail(this.storeItemId).subscribe(
      (storeItemDetail: StoreItemDetailResponse) => {
        this.spinnerService.hide();
        this.storeItem = true;
        if (storeItemDetail.formSchema) {
          this.formSchema = JSON.parse(storeItemDetail.formSchema);
        }
        this.storeItemDetail = storeItemDetail;
        console.log(this.storeItemDetail);
        this.storeItemDetailForm.get('storeItemName').setValue(this.storeItemDetail.storeItemName);
        this.storeItemDetailForm.get('storeItemDescription').setValue(this.storeItemDetail.storeItemDescription);
        if (this.storeItemDetail.showTargetDevice) {
          this.storeItemDetailForm.get('targetDevice').setValidators(Validators.required);
        }
        this.storeItemDetailForm.updateValueAndValidity();
      },
      err => {
        console.error(err);
        this.router.navigate([CommonConstants.STORE_COMPONENT]);
      }
    );



    this.storeItemDetailForm = this.formBuilder.group({
      storeItemName: this.formBuilder.control({ value: '', disabled: true }),
      storeItemDescription: this.formBuilder.control({ value: '', disabled: true }),
      targetDevice : this.formBuilder.control({value: null})
    });

    this.searchString = StoreFilterComponent.searchString;

    // Scroll to top of page
    document.body.scrollTop = document.documentElement.scrollTop = 0;

  }
  isfileuploadformvalid(formvalid: boolean) {
    this.fileUploadForm = formvalid;
  }

  checkTargetDevice() {
    if (this.storeItemDetail.showTargetDevice && (this.targetDeviceId.toString() === this.defaultTargetDevice.toString())) {
       return false;
    }
    return true;
  }

setTargetItem(targetId) {
  this.targetDeviceId = targetId;
}

  createRequest() {
    this.loading = true;
    this.spinnerService.show();
    this.storeItemRequest = new StoreItemRequest();
    this.serverError = null;
    if (this.storeItemDetailForm.valid && this.fileUploadForm && this.checkTargetDevice() &&
    this.checkForcustomformValidation()) {
      this.storeItemRequest.requestDescription = this.storeItemDetailForm.value.tinyMce.tinymce;
      this.storeItemRequest.targetDeviceId = this.targetDeviceId;

      // Adding Conditional Check as Additional Info is now based on privileges
      if (this.showAdditionalInfo) {
        this.storeItemRequest.contactEmail = this.storeItemDetailForm.value.contactInfo.email;
        this.storeItemRequest.contactPhone = this.storeItemDetailForm.value.contactInfo.phone;
        this.storeItemRequest.location = this.storeItemDetailForm.value.additionalInfo.location;
        this.storeItemRequest.contactType = parseInt(this.storeItemDetailForm.value.contactInfo.contactType, 10);
        this.storeItemRequest.contactTime = parseInt(this.storeItemDetailForm.value.contactInfo.contactTime, 10);
        this.storeItemRequest.contactTimePeriod = parseInt(this.storeItemDetailForm.value.contactInfo.contactTimeTt, 10);
      }

      if (this.storeItemRequest.contactType === 0) {
        this.storeItemRequest.contactEmail = null;
        this.storeItemRequest.contactPhone = null;
        this.storeItemRequest.contactTime = null;
        this.storeItemRequest.contactTimePeriod = null;
      }
      if (this.storeItemRequest.contactType === 1) {
        this.storeItemRequest.contactPhone = null;
        this.storeItemRequest.contactTime = null;
        this.storeItemRequest.contactTimePeriod = null;
      }

      if (this.storeItemRequest.contactType === 2) {
        this.storeItemRequest.contactEmail = null;
      }

      for (let i = 0; i < this.storeItemDetail.customFields.length; i++) {
        let customField: CustomField = this.storeItemDetail.customFields[i];
        if (!this.storeItemRequest.customFields) {
          this.storeItemRequest.customFields = new Array<CustomFieldRequest>();
        }
        if (customField.clientEditable !== 0) {
          let customfieldRequest: CustomFieldRequest = new CustomFieldRequest();
          customfieldRequest.fieldId = customField.fieldId;
          if (customField.dataType === 4) { // Currency
            customfieldRequest.fieldValue = this.getActualCurrencyValue(this.storeItemDetailForm.value[customField.fieldId].data);
          } else {
            customfieldRequest.fieldValue = this.storeItemDetailForm.value[customField.fieldId].data;
          }
          this.storeItemRequest.customFields.push(customfieldRequest);
        }
      }
      if (this.ccList) {
        let ccListEmail = this.ccList.map(userInfo => userInfo.email);
        this.storeItemRequest.customerCC = ccListEmail.join(','); // Make a string of all emails seperated by comma.
      }

       // customForm
       if (this.storeItemDetail.formSchema) {
        let formData: string;
        if (this.storeItemDetailForm.value.customform.formioform.hasOwnProperty('components')) {
          formData = this.getCustomFormData(this.storeItemDetailForm.value.customform.formioform);
        } else {
          formData = JSON.stringify(this.storeItemDetailForm.value.customform.formioform);
        }
        this.storeItemRequest.formSubmission = formData;
      }

      // creating Request
      this.storeitemdetailservice.createRequest(this.storeItemRequest, this.storeItemId).subscribe(
        (requestId: number) => {
          const alertMessage = new AlertMessage();
          alertMessage.type = 'info';
          alertMessage.message = 'Alert.requestCreated';
          alertMessage.params = requestId.toString();
          this.storeItemFileUpload.files = this.validFileList;
          this.storeItemFileUpload.requestId = requestId;
          if (this.validFileList.length > 0) {
            this.storeitemdetailservice.uploadAttachments(this.storeItemFileUpload).subscribe(
              (fileUploadStatus: FileUploadStatus) => {
                  this.loading = false;
                if (fileUploadStatus.failureFiles && fileUploadStatus.failureFiles.length > 0) {
                    alertMessage.status = this.zsdTranslate.getTranslatedString('Alert', 'fileUploadfailure');
                    alertMessage.status += (fileUploadStatus.failureFiles.join(','));
                  }
                  this.alertService.displayAlert(alertMessage);
                  this.router.navigate([CommonConstants.STORE_COMPONENT]);
              },
              err => {
                  this.loading = false;
                  if (err.error.localizedMessage) {
                    alertMessage.status = err.error.localizedMessage;
                  } else {
                    alertMessage.status = err.error.message;
                  }
                  this.alertService.displayAlert(alertMessage);
                  this.router.navigate([CommonConstants.STORE_COMPONENT]);
              });
          } else {
              this.loading = false;
              this.alertService.displayAlert(alertMessage);
              this.router.navigate([CommonConstants.STORE_COMPONENT]);
          }

        },
        err => {
          this.loading = false;
          this.serverError = 'Unable to connect to the server.';
          if (err.error.localizedMessage) {
            this.serverError = err.error.localizedMessage;
          } else if (err.error.message) {
            this.serverError = err.error.message;
          }
        }
      );
    } else {
      this.loading = false;
      if (this.storeItemDetail.showTargetDevice) {
        this.storeItemDetailForm.controls['targetDevice'].markAsTouched();
      }
      // marking fields as touched to display error message if form is invalid
      (this.storeItemDetailForm.controls['contactInfo'] as FormGroup).controls['email'].markAsTouched();
      (this.storeItemDetailForm.controls['contactInfo'] as FormGroup).controls['phone'].markAsTouched();

      for (let i = 0; i < this.storeItemDetail.customFields.length; i++) {
        let fieldId = this.storeItemDetail.customFields[i].fieldId + '';
        (this.storeItemDetailForm.controls[fieldId] as FormGroup).controls['data'].markAsTouched();
      }
    }

  }

  getActualCurrencyValue(formattedCurrencyValue) {
    if (formattedCurrencyValue) {
      formattedCurrencyValue = formattedCurrencyValue.replace(/[^\d\.\-eE+]/g, '');
      formattedCurrencyValue = formattedCurrencyValue ? parseFloat(formattedCurrencyValue) : 0;
      formattedCurrencyValue = !formattedCurrencyValue ? 0 : formattedCurrencyValue;
    }

    return formattedCurrencyValue;
  }

  cancelRequest() {
    this.router.navigate([CommonConstants.STORE_COMPONENT]);
  }

  setFocusToCCField() {
    document.getElementById('input-user' + this.index).focus();
  }

  addToCCList(selectedUser: ClientInfo) {
    this.ccList.push(selectedUser);
    this.ccField.setValue(null);
    document.getElementById('input-user' + this.index).focus();

    this.currentCcUserIndex = -1;
  }

  removeFromCCList(indexToRemove: number) {
    this.ccList.splice(indexToRemove, 1);
    document.getElementById('input-user' + this.index).focus();
  }

  ccListKeyPressAction(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    // Backspace action, remove last user
    if (charCode === 8 && !this.ccField.value && this.ccList.length > 0) {
      this.ccList.splice(this.ccList.length - 1, 1);
      document.getElementById('input-user' + this.index).focus();
      this.currentCcUserIndex = -1;
    } else if (charCode === 40) { // Key Down action
      event.preventDefault();
      this.currentCcUserIndex++;
      if (this.currentCcUserIndex >= this.userSearchCurrentDisplayedCount) {
        this.currentCcUserIndex = 0;
      }
      let listid = `user${this.currentCcUserIndex}`;
      let elmnt = document.getElementById(listid);
      elmnt.scrollIntoView(false);
      window.scrollTo(0, 0);
    } else if (charCode === 38) { // Key up action
      event.preventDefault();
      this.currentCcUserIndex--;
      if (this.currentCcUserIndex < 0) {
        this.currentCcUserIndex = (this.userSearchCurrentDisplayedCount - 1);
      }
      let listid = `user${this.currentCcUserIndex}`;
      let elmnt = document.getElementById(listid);
      elmnt.scrollIntoView(false);
      window.scrollTo(0, 0);
    } else if (charCode === 13) { // Enter action
      event.preventDefault();
      document.getElementById('user' + this.currentCcUserIndex).click();
    } else {
      this.currentCcUserIndex = -1;
    }

    return true;
  }

  getRequestDetails(requestNumber) {
    this.requestDetailService.getRequestDetail(requestNumber)
      .subscribe((reqDetailResponse: RequestDetailResponse) => {
        this.requestDetailResponse = reqDetailResponse;
        this.requestNotesResponse = reqDetailResponse.requestNotes;
        this.requestInfo = reqDetailResponse.requestInfo;
        this.requestCustomfield = reqDetailResponse.requestCustomFieldInfo;
        this.ccList = this.requestInfo.ccList;
        this.customFormField = reqDetailResponse.customFormFields;
        if (this.validateSource(this.requestInfo.description)) {
          setTimeout(() => {
            this.determineView();
          }, 1);
        }
        if (this.customFormField.length > 0) {
          this.setDataForCustomformFields();
        }
      });
}

validateSource(s) {
  if (typeof s !== 'string') {
    return false;
  } else {
    return true;
  }
}

determineView() {
  if (this.requestInfo.description.length <= this.maxLength) {
    this.currentText = this.requestInfo.description;
    this.isCollapsed = false;
    return;
  }

  if (this.isCollapsed === true) {
    this.currentText = this.requestInfo.description.substring(0, this.maxLength) + ' ...';
  } else if (this.isCollapsed === false) {
    this.currentText = this.requestInfo.description;
  }
}

setDataForCustomformFields() {
  let chunkSize = 2;
  let arr = this.customFormField;
  let groups = arr.map(function (e, i) {
    return i % chunkSize === 0 ? arr.slice(i, i + chunkSize) : null;
    console.log(e);
  });
  this.matrix = groups;
}

getRequestDetailsAfterUpdate(requestNumber) {
  this.requestDetailService.getRequestDetail(requestNumber)
    .subscribe((reqDetailResponse: RequestDetailResponse) => {
      this.requestDetailResponse = reqDetailResponse;
        this.requestNotesResponse = reqDetailResponse.requestNotes;
        this.requestInfo = reqDetailResponse.requestInfo;
        this.requestCustomfield = reqDetailResponse.requestCustomFieldInfo;
        this.ccList = this.requestInfo.ccList;
        this.requestListService.publishRequestChanges(this.requestInfo);
      if (this.validateSource(this.requestInfo.description)) {
        setTimeout(() => {
          this.determineView();
        }, 1);
      }
    });
}

public getUserDisplayString(user: ClientInfo): string {
  if (user.fullName) {
      return user.fullName + '<' + user.email + '>';
  }

  return user.email;
}

  selectedFilesList(fileList: Array<File>) {
    const newFileList = [];
    for (let i = 0; i < fileList.length; i++) {
      newFileList.push(fileList[i]);
    }
    this.validFileList = newFileList;
  }

  getTargetDeviceNoSelectionString(): string {
    if (this.storeItemDetail.targetDevices && this.storeItemDetail.targetDevices.length > 0) {
      return 'StoreItemDetail.defaultTargetDeviceString';
    } else {
      return 'StoreItemDetail.noDeviceFound';
    }
  }

  scrollEndForCustomerSearch() {
    let s = $('#storedetail-search-list').prop('scrollHeight');
    let s1 = $('#storedetail-search-list').scrollTop() + $('#storedetail-search-list').height();
    if ((s / 2) < s1) {
      if ( this.userSearchCurrentDisplayedCount < this.ccUserSearchResultCount) {
        this.usersLoading = true;
        this.userSearchOffset = this.userSearchOffset + 1;
        this.userSearchLimit = 10;
        this.userSearchCurrentDisplayedCount = this.ccUserSearchResultCount;
        this.requestDetailService.findUser(this.userSearchTerm, this.userSearchOffset, this.userSearchLimit)
        .pipe(debounceTime(400)
          , distinctUntilChanged()
          ).subscribe((resp) => {
            this.usersLoading = false;
            this.ccUserSearchResultCount = resp.resultCount;
            let temp = this.userSearchInfo.results;
            temp = temp.concat(resp.results);
            this.userSearchInfo = resp;
            this.userSearchInfo.results = temp;
            this.userSearchCurrentDisplayedCount = this.userSearchInfo.results.length;
          });
       }
    }
  }
  getCustomFormData(data) {
    let submitData = {};
    data.components.forEach(component => {
      if (component.key === 'submit') {
        let key = component.key;
        let value = true;
        submitData[key] = value;
      } else {
        let key = component.key;
        let value;
        if (component.defaultValue == null) {
          value = '';
        } else {
          value = component.defaultValue;
        }
        submitData[key] = value;
      }
    });
    return JSON.stringify(submitData);
  }
  checkForcustomformValidation(): boolean {
    let formValid = true;
    if (this.storeItemDetail.formSchema && !this.storeItemDetailForm.value.customform.formiovalid) {
      formValid = false;
    }
    return formValid;
  }
  callFormioSubmitButton() {
    if (this.storeItemDetail.formSchema) {
      this.formio.checkSubmit();
    }
  }
}
